import { Button, Checkbox, useLocalization } from '@magicdoorinc/ui';
import { createSignal } from 'solid-js';
import { CompanyTypeConfirmStep, useCompanyTypeConfirm } from '~/contexts/local';
import type { Component } from 'solid-js';

const ConfirmationContent: Component = () => {
  const { t } = useLocalization();

  return (
    <div class="flex flex-col gap-6 p-6">
      <div class="text-center">
        <h2 class="text-2xl font-semibold text-text-01">{t('Confirm Self-Manager Mode')}</h2>
      </div>

      <div class="flex flex-col gap-4 text-text-01">
        <p class="text-base">
          {t('Self-Manager mode is for people who')} <span class="font-semibold">{t('only manage their own properties.')}</span>
        </p>
        <p class="text-base">{t('Only continue if this describes you:')}</p>

        <ul class="ml-5 flex list-disc flex-col gap-2 text-base">
          <li>{t('You own the properties yourself')}</li>
          <li>
            {t('You do ')}
            <span class="font-semibold">{t('not')}</span>
            {t(' report to any other owners')}
          </li>
          <li>
            {t('You do ')}
            <span class="font-semibold">{t('not')}</span>
            {t(' need to keep your management company income separate from the property income')}
          </li>
        </ul>

        <p class="mt-2 text-base text-text-02">
          {t('This choice sets up your account for a simpler experience that matches how you work.')}
        </p>
      </div>
    </div>
  );
};

export const ConfirmationFooter: Component = () => {
  const { t } = useLocalization();
  const { setStep, handleConfirmationConfirm } = useCompanyTypeConfirm();
  const [checked, setChecked] = createSignal(false);

  const handlePrevious = () => {
    setStep(CompanyTypeConfirmStep.SelectCompanyType);
  };

  return (
    <div class="flex flex-col border-t border-separator bg-white">
      <div class="flex cursor-pointer items-center gap-3 bg-gray-50 px-6 py-4 hover:bg-gray-100" onClick={() => setChecked(!checked())}>
        <Checkbox class="size-6 rounded-md" checked={checked()} />
        <span class="text-base font-medium text-text-01">
          {t('I have read the message above and confirm this is the right mode for me')}
        </span>
      </div>
      <div class="flex items-center justify-between gap-4 px-6 py-4">
        <Button variant="outlined" onClick={handlePrevious} class="px-8">
          {t('Back')}
        </Button>
        <Button
          onClick={handleConfirmationConfirm}
          loading={handleConfirmationConfirm.loading}
          disabled={!checked()}
          class="flex-1 justify-center px-8 text-base">
          {t('Yes, Set Up Self-Manager Mode')}
        </Button>
      </div>
    </div>
  );
};

export default ConfirmationContent;
